export default "__VITE_ASSET__ixby28qJ__"